import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createErrorResult, createExceptionResult, createSuccessResult } from '@atlassian/commerce-resultful';
export { isSuccessful, isFailure, isError, isException } from '@atlassian/commerce-resultful';
/**
 * A set of GET/POST/etc HTTP helpers that can generally be applied to all APIs in HAMS
 */

/**
 * Wrapper around the normal fetch client for GET calls to HAMS.
 */
export var get = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetch, url) {
    var options,
        response,
        json,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.prev = 1;
            _context.next = 4;
            return fetch(url, _objectSpread(_objectSpread({}, options), {}, {
              headers: _objectSpread({
                Accept: 'application/json'
              }, options.headers),
              method: 'GET'
            }));

          case 4:
            response = _context.sent;

            if (!(response.status === 204)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", createSuccessResult(null));

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            json = _context.sent;

            if (!response.ok) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", createSuccessResult(_objectSpread(_objectSpread({}, json), {}, {
              status: response.status
            })));

          case 14:
            return _context.abrupt("return", createErrorResult(json));

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", createExceptionResult(_context.t0));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));

  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();